
export const rad2deg = (angle: number) => angle * 180 / Math.PI;

export const deg2rad = (degrees: number) => degrees / 180 * Math.PI;
